import { datadogRum } from '@datadog/browser-rum';
import { APPLICATION_ID, APPLICATION_SERVICE_NAME, CLIENT_TOKEN } from '../constants/datadog';

export function initDataDog() {
  datadogRum.init({
    applicationId: APPLICATION_ID,
    clientToken: CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: APPLICATION_SERVICE_NAME,
    version: process.env.npm_package_version,
    env: 'prod',
    sessionReplaySampleRate: 0,
    trackUserInteractions: false,
    defaultPrivacyLevel: 'mask'
  });
}
